<template>
  <div class="repair-flow-template-container">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t("repairFlowTemplate.searchCondition") }}</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            v-model="searchForm.templateName"
            :placeholder="$t('repairFlowTemplate.templateNamePlaceholder')"
            clearable
          />
        </el-col>

        <el-col :span="6">
          <el-select
            v-model="searchForm.isEnable"
            :placeholder="$t('repairFlowTemplate.statePlaceholder')"
            clearable
            style="width: 100%"
          >
            <el-option label="启用" value="1" />
            <el-option label="禁用" value="0" />
          </el-select>
        </el-col>

        <el-col :span="6">
          <el-button type="primary" @click="queryList">
            <i class="el-icon-search"></i>
            {{ $t("repairFlowTemplate.search") }}
          </el-button>
          <el-button @click="resetSearch" style="margin-left: 10px">
            <i class="el-icon-refresh"></i>
            {{ $t("repairFlowTemplate.reset") }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 列表 -->
    <el-card class="list-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t("repairFlowTemplate.listTitle") }}</span>
        <div>
          <el-button type="success" size="small" @click="handleReference">
            <i class="el-icon-copy-document"></i>
            引用模版
          </el-button>
          <el-button type="primary" size="small" @click="handleAdd">
            <i class="el-icon-plus"></i>
            {{ $t("repairFlowTemplate.add") }}
          </el-button>
        </div>
      </div>

      <el-table :data="tableData" border v-loading="loading">
        <el-table-column
          prop="templateName"
          :label="$t('repairFlowTemplate.templateName')"
          align="center"
        />
        <el-table-column prop="templateCode" label="报修类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.templateCode == 0 ? "室内报修" : "公区报修" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="isEnable"
          :label="$t('repairFlowTemplate.state')"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.isEnable == 1 ? 'success' : 'info'">
              {{ scope.row.isEnable == 1 ? "启用" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('repairFlowTemplate.createTime')"
          align="center"
          width="180"
        />
        <el-table-column
          :label="$t('repairFlowTemplate.operation')"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.row)"
            >
              {{ $t("repairFlowTemplate.edit") }}
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
            >
              {{ $t("repairFlowTemplate.delete") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :width="form.id ? '1100px' : '600px'"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item
          :label="$t('repairFlowTemplate.templateName')"
          prop="templateName"
        >
          <el-input
            v-model="form.templateName"
            :placeholder="$t('repairFlowTemplate.templateNamePlaceholder')"
          />
        </el-form-item>
        <el-form-item :label="$t('repairFlowTemplate.state')" prop="isEnable">
          <el-select
            v-model="form.isEnable"
            :placeholder="$t('repairFlowTemplate.statePlaceholder')"
            style="width: 100%"
          >
            <el-option label="启用" value="1" />
            <el-option label="禁用" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item
          label="报修类型"
          prop="templateCode"
          class="repair-type-form-item"
        >
          <el-radio-group
            v-model="form.templateCode"
            class="repair-type-radio-group"
          >
            <el-radio :label="0">室内报修</el-radio>
            <el-radio :label="1">公区报修</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <!-- 节点配置（编辑时显示） -->
      <div v-if="form.id" class="node-config-section">
        <div class="node-header">
          <span>节点配置</span>
          <el-button type="primary" size="mini" @click="handleAddNode">
            <i class="el-icon-plus"></i> 添加节点
          </el-button>
        </div>
        <el-table :data="nodeList" border size="small" v-loading="nodeLoading">
          <el-table-column
            prop="sortOrder"
            label="顺序"
            align="center"
            width="80"
          />
          <el-table-column
            prop="nodeName"
            label="节点名称"
            align="left"
            width="200"
          />
          <el-table-column
            prop="semanticTag"
            label="关联动作"
            align="center"
            width="160"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.semanticTag }}</span>
            </template>
          </el-table-column>
		  
          <el-table-column prop="handlerKey" label="关联角色" align="center">
            <template slot-scope="scope">
              {{ getRoleName(scope.row.handlerKey) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="hasBranch"
            label="是否存在分支"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span :style="{ color: scope.row.hasBranch == 1 ? 'red' : '' }">{{
                scope.row.hasBranch == 1 ? "是" : "否"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="canReject" label="是否允许驳回" align="center">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.canReject == 1 ? 'red' : '' }">{{
                scope.row.canReject == 1 ? "是" : "否"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            width="160"
          />
          <el-table-column
            label="操作"
            align="center"
            width="150"
            v-if="form.id"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="handleEditNode(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDeleteNode(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer">
        <el-button @click="dialogVisible = false">{{
          $t("repairFlowTemplate.cancel")
        }}</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit"
          >{{ $t("repairFlowTemplate.confirm") }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 节点配置弹窗 -->
    <el-dialog
      :title="nodeDialogTitle"
      :visible.sync="nodeDialogVisible"
      width="600px"
      append-to-body
    >
      <el-form
        ref="nodeForm"
        :model="nodeForm"
        :rules="nodeRules"
        label-width="120px"
      >
        <el-form-item label="节点名称" prop="nodeName">
          <el-input
            v-model="nodeForm.nodeName"
            placeholder="请输入节点名称"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="顺序" prop="sortOrder">
          <el-input
            v-model.number="nodeForm.sortOrder"
            placeholder="请输入顺序"
          />
        </el-form-item>
        <el-form-item label="关联动作" prop="semanticTag">
          <el-select
            v-model="nodeForm.semanticTag"
            placeholder="请选择关联动作"
            style="width: 100%"
          >
            <el-option
              v-for="dict in dictList"
              :key="dict.id"
              :label="dict.name"
              :value="dict.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="是否需要签名"
          prop="isSign"
          v-if="
            nodeForm.semanticTag &&( nodeForm.semanticTag.indexOf('审') !== -1
			|| nodeForm.semanticTag.indexOf('验') !== -1)"
        >
          <el-radio-group v-model="nodeForm.isSign">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关联角色" prop="handlerKey">
          <el-select
            v-model="nodeForm.handlerKey"
            placeholder="请选择关联角色"
            style="width: 100%"
          >
            <el-option
              v-for="role in roleList"
              :key="role.pgId"
              :label="role.name"
              :value="role.pgId"
            />
            <el-option label="业主" value="-1" />
          </el-select>
        </el-form-item>

        <el-form-item label="是否存在分支" prop="hasBranch">
          <el-radio-group v-model="nodeForm.hasBranch">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="流转节点"
          prop="jumpTag"
          v-if="nodeForm.hasBranch == 1"
        >
          <el-select
            v-model="nodeForm.jumpTag"
            placeholder="请选择流转节点"
            style="width: 100%"
          >
            <el-option
              v-for="node in nodeList"
              :key="node.id"
              :label="node.nodeName"
              :value="String(node.id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否允许驳回" prop="canReject">
          <el-radio-group v-model="nodeForm.canReject">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="驳回节点"
          prop="rejectTarget"
          v-if="nodeForm.canReject == 1"
        >
          <el-select
            v-model="nodeForm.rejectTarget"
            placeholder="请选择驳回节点"
            style="width: 100%"
          >
            <el-option
              v-for="node in nodeList"
              :key="node.id"
              :label="node.nodeName"
              :value="String(node.id)"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="nodeDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="nodeSubmitLoading"
          @click="handleNodeSubmit"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 引用模版弹窗 -->
    <el-dialog
      title="引用模版"
      :visible.sync="referenceDialogVisible"
      width="1000px"
    >
      <el-table
        :data="referenceList"
        border
        highlight-current-row
        @row-click="handleSelectTemplate"
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column
          prop="communityName"
          label="小区名称"
          align="center"
          width="150"
        />
        <el-table-column
          prop="templateName"
          label="模板名称"
          align="center"
          min-width="200"
        />
        <el-table-column
          prop="templateCode"
          label="报修类型"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.templateCode == 0 ? "室内报修" : "公区报修" }}
          </template>
        </el-table-column>
        <el-table-column prop="isEnable" label="状态" align="center" width="80">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.isEnable == 1 ? 'success' : 'info'"
              size="mini"
            >
              {{ scope.row.isEnable == 1 ? "启用" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="180"
        />
      </el-table>
      <div slot="footer">
        <el-button @click="referenceDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listRepairFlowTemplates,
  deleteRepairFlowTemplate,
  saveOrUpdateFlowTemplate,
  queryFlowNodeConfig,
  saveOrUpdateFlowNodeConfig,
  deleteFlowNodeConfig,
} from "@/api/work/repairFlowTemplateApi";
import { queryPrivilegeGroup } from "@/api/role/roleApi";
import { getDictList } from "@/api/dev/dictApi";

export default {
  name: "RepairFlowTemplateList",
  data() {
    return {
      searchForm: {
        templateName: "",
        isEnable: "",
      },
      tableData: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: "",
      submitLoading: false,
      form: {
        id: null,
        templateName: "",
        templateCode: 0,
        isEnable: "1",
      },
      rules: {
        templateName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
        templateCode: [
          { required: true, message: "请选择报修类型", trigger: "change" },
        ],
        isEnable: [
          { required: true, message: "请选择状态", trigger: "change" },
        ],
      },
      // 节点配置
      nodeList: [],
      nodeLoading: false,
      nodeDialogVisible: false,
      nodeDialogTitle: "",
      nodeSubmitLoading: false,
      nodeForm: {
        id: null,
        templateId: null,
        nodeName: "",
        sortOrder: 100,
        semanticTag: "",
        handlerType: 1,
        handlerKey: "",
        canReject: 0,
        rejectTarget: "",
        conditionMinAmount: 0,
        hasBranch: 0,
        jumpTag: "",
        // 是否需要签名：默认为0
        isSign: 0,
      },
      nodeRules: {
        nodeName: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
        ],
        sortOrder: [{ required: true, message: "请输入顺序", trigger: "blur" }],
        handlerKey: [
          { required: true, message: "请选择关联角色", trigger: "change" },
        ],
        semanticTag: [
          { required: true, message: "请选择关联动作", trigger: "change" },
        ],
      },
      // 角色列表
      roleList: [],
      // 字典列表（关联动作）
      dictList: [],
      // 引用模版弹窗
      referenceDialogVisible: false,
      // 引用模版列表（用于弹框显示）
      referenceList: [],
    };
  },
  mounted() {
    this.loadList();
    this.loadRoleList();
    this.loadDictList();
  },
  methods: {
    async loadRoleList() {
      try {
        const res = await queryPrivilegeGroup({ communityId: -1 });
        // 接口直接返回数组
        this.roleList = Array.isArray(res) ? res : res.data || [];
      } catch (error) {
        console.log("获取角色列表失败:", error);
        this.roleList = [];
      }
    },
    async loadDictList() {
      try {
        const res = await getDictList({ page: 1, row: 100, specId: 8 });
        this.dictList = res.data || [];
      } catch (error) {
        console.log("获取字典列表失败:", error);
        this.dictList = [];
      }
    },
    getRoleName(pgId) {
      if (pgId === "-1" || pgId === -1) return "业主";
      const role = this.roleList.find((r) => r.pgId === pgId);
      return role ? role.name : pgId;
    },
    async loadList(isAll = 0) {
      this.loading = true;
      try {
        const params = { ...this.searchForm };
        Object.keys(params).forEach((key) => {
          if (params[key] === "") delete params[key];
        });

        // 添加 isAll 参数
        params.isAll = isAll;

        const { data } = await listRepairFlowTemplates(params);
        this.tableData = data;
      } catch (error) {
        console.log("获取列表失败:", error);
        this.$message.error("获取列表失败");
      } finally {
        this.loading = false;
      }
    },
    queryList() {
      this.loadList();
    },
    resetSearch() {
      this.searchForm = {
        templateName: "",
        isEnable: "",
      };
      this.queryList();
    },
    handleAdd() {
      this.dialogTitle = "新增模板";
      this.form = {
        id: null,
        templateName: "",
        templateCode: 0,
        isEnable: "1",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    handleEdit(row) {
      this.dialogTitle = "编辑模板";
      this.form = {
        id: row.id,
        templateName: row.templateName,
        templateCode:
          row.templateCode !== undefined ? Number(row.templateCode) : 0,
        isEnable: String(row.isEnable),
      };
      this.dialogVisible = true;
      this.loadNodeList(row.id);
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    async loadNodeList(templateId) {
      this.nodeLoading = true;
      try {
        const { data } = await queryFlowNodeConfig({
          templateId,
          page: 1,
          row: 100,
        });
        this.nodeList = data;
      } catch (error) {
        console.log("获取节点配置失败:", error);
        this.nodeList = [];
      } finally {
        this.nodeLoading = false;
      }
    },
    handleAddNode() {
      this.nodeDialogTitle = "添加节点";
      this.nodeForm = {
        id: null,
        templateId: this.form.id,
        nodeName: "",
        sortOrder: (this.nodeList.length + 1) * 100,
        semanticTag: "",
        handlerType: 1,
        handlerKey: "",
        canReject: 0,
        rejectTarget: "",
        conditionMinAmount: 0,
        hasBranch: 0,
        jumpTag: "",
        // 新增节点默认不需要签名
        isSign: 0,
      };
      this.nodeDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.nodeForm && this.$refs.nodeForm.clearValidate();
      });
    },
    handleEditNode(row) {
      this.nodeDialogTitle = "编辑节点";
      this.nodeForm = {
        id: row.id,
        templateId: this.form.id,
        nodeName: row.nodeName,
        sortOrder: row.sortOrder,
        semanticTag: row.semanticTag || "",
        handlerType: 1,
        handlerKey: row.handlerKey,
        canReject: row.canReject,
        rejectTarget: row.rejectTarget ? String(row.rejectTarget) : "",
        conditionMinAmount: row.conditionMinAmount || 0,
        hasBranch: row.hasBranch || 0,
        jumpTag: row.jumpTag || "",
        // 旧数据如果没有 isSign，默认为0
        isSign:
          row.isSign !== undefined && row.isSign !== null ? row.isSign : 0,
      };
      this.nodeDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.nodeForm && this.$refs.nodeForm.clearValidate();
      });
    },
    handleNodeSubmit() {
      this.$refs.nodeForm.validate(async (valid) => {
        if (!valid) return;
        this.nodeSubmitLoading = true;
        try {
          // 获取角色名称
          const role = this.roleList.find(
            (r) => r.pgId === this.nodeForm.handlerKey
          );
          const submitData = {
            ...this.nodeForm,
            keyName: role ? role.name : "",
            // 将字符串类型的 ID 转换为数字类型
            rejectTarget: this.nodeForm.rejectTarget
              ? Number(this.nodeForm.rejectTarget)
              : 0,
            jumpTag: this.nodeForm.jumpTag ? Number(this.nodeForm.jumpTag) : "",
            // 确保 isSign 被传递，默认为0
            isSign:
              this.nodeForm.isSign !== undefined &&
              this.nodeForm.isSign !== null
                ? this.nodeForm.isSign
                : 0,
          };
          await saveOrUpdateFlowNodeConfig(submitData);
          this.$message.success(this.nodeForm.id ? "修改成功" : "添加成功");
          this.nodeDialogVisible = false;
          this.loadNodeList(this.form.id);
        } catch (error) {
          console.log("保存节点失败:", error);
          this.$message.error(error.message || "保存节点失败");
        } finally {
          this.nodeSubmitLoading = false;
        }
      });
    },
    async handleDeleteNode({ id }) {
      try {
        await this.$confirm("确定要删除该节点吗？", "提示", {
          type: "warning",
        });
        await deleteFlowNodeConfig(id);
        this.$message.success("删除成功");
        this.loadNodeList(this.form.id);
      } catch (error) {
        if (error !== "cancel") {
          console.log("删除节点失败:", error);
          this.$message.error("删除节点失败");
        }
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.submitLoading = true;
        try {
          // 保存模版
          await saveOrUpdateFlowTemplate(this.form);
          this.$message.success(this.form.id ? "修改成功" : "新增成功");

          this.dialogVisible = false;
          this.loadList();
        } catch (error) {
          console.log("保存失败:", error);
          this.$message.error(error.message || "保存失败");
        } finally {
          this.submitLoading = false;
        }
      });
    },
    async handleDelete({ id }) {
      try {
        await this.$confirm("确定要删除该模板吗？", "提示", {
          type: "warning",
        });
        await deleteRepairFlowTemplate(id);
        this.$message.success("删除成功");
        this.loadList();
      } catch (error) {
        if (error !== "cancel") {
          console.log("删除失败:", error);
          this.$message.error("删除失败");
        }
      }
    },
    // 打开引用模版弹窗
    async handleReference() {
      // 查询所有模版（isAll=1）
      this.loading = true;
      try {
        const params = { isAll: 1 };
        const { data } = await listRepairFlowTemplates(params);
        this.referenceList = data;
      } catch (error) {
        console.log("获取引用模版列表失败:", error);
        this.$message.error("获取引用模版列表失败");
      } finally {
        this.loading = false;
      }
      this.referenceDialogVisible = true;
    },
    // 选择引用的模版
    async handleSelectTemplate(row) {
      try {
        await this.$confirm(`确定要引用模板"${row.templateName}"吗？`, "提示", {
          type: "info",
        });

        this.referenceDialogVisible = false;

        // 1. 记录引用的模板名称
        const newTemplateName = row.templateName + "-副本";

        // 2. 创建新模版
        const newTemplateData = {
          templateName: newTemplateName,
          templateCode:
            row.templateCode !== undefined ? Number(row.templateCode) : 0,
          isEnable: String(row.isEnable),
        };

        await saveOrUpdateFlowTemplate(newTemplateData);
        console.log("已创建新模版:", newTemplateName);

        // 3. 刷新列表，找到新创建的模版ID（使用 isAll=0 查询父页面列表）
        await this.loadList(0);

        // 通过名称匹配找到新模版ID
        const newTemplate = this.tableData.find(
          (item) => item.templateName === newTemplateName
        );

        if (!newTemplate || !newTemplate.id) {
          this.$message.error("无法找到新创建的模版");
          return;
        }

        const newTemplateId = newTemplate.id;
        console.log("新模版ID:", newTemplateId);

        // 4. 加载原模版的节点配置
        await this.loadNodeList(row.id);
        console.log("原模版节点列表:", this.nodeList);

        // 5. 复制节点到新模版
        if (this.nodeList.length > 0) {
          for (const node of this.nodeList) {
            try {
              await saveOrUpdateFlowNodeConfig({
                ...node,
                templateId: newTemplateId,
                id: null,
              });
              console.log("复制节点成功:", node.nodeName);
            } catch (nodeError) {
              console.log("复制节点失败:", node.nodeName, nodeError);
            }
          }
          this.$message.success(
            `已成功引用模板"${row.templateName}"，共复制${this.nodeList.length}个节点配置`
          );
        } else {
          this.$message.success(
            `已成功引用模板"${row.templateName}"，该模板没有节点配置`
          );
        }

        // 6. 打开编辑弹窗，加载新模版的节点配置
        this.dialogTitle = "编辑引用的模版";
        this.form = {
          id: newTemplateId,
          templateName: newTemplateName,
          templateCode: newTemplate.templateCode,
          isEnable: String(newTemplate.isEnable),
        };
        this.dialogVisible = true;

        // 7. 加载新模版的节点配置
        await this.loadNodeList(newTemplateId);

        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate();
        });
      } catch (error) {
        if (error !== "cancel") {
          console.log("引用模版失败:", error);
          this.$message.error("引用模版失败");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.repair-flow-template-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .list-card {
    margin-bottom: 20px;
  }

  .footer-row {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  .node-config-section {
    margin-top: 20px;
    border-top: 1px solid #ebeef5;
    padding-top: 15px;

    .node-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      font-weight: bold;
    }
  }

  ::v-deep .el-form-item {
    &.repair-type-form-item {
      .el-form-item__content {
        text-align: left !important;

        .repair-type-radio-group {
          text-align: left;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 40px;
          .el-radio {
            margin-right: 20px;
          }
        }
      }
    }
  }
}
</style>
